import Backbone from "backbone";
import * as _ from "underscore";

export default class EventedModel extends Backbone.Model {
  _revertAttributes: { [key: string]: any };

  constructor(...args) {
    super(...args);
    _.bindAll(this, "mark_to_revert", "revert");
    this.mark_to_revert();
  }

  sync(method, model, options) {
    const that = this;
    options = options || {};

    const success = options.success;
    options.success = function (successModel, data, successOptions) {
      const result = success.call(that, successModel, data, successOptions);
      that.mark_to_revert();
      return result;
    };

    const value = Backbone.sync.call(this, method, model, options);
    return value;
  }

  mark_to_revert() {
    this._revertAttributes = _.clone(this.attributes);
    return this._revertAttributes;
  }

  revert() {
    if (this._revertAttributes) {
      return this.set(this._revertAttributes, {
        /*silent: true*/
      });
    }
  }
}
